import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import { Range } from 'rc-slider'
import Config from "../../../../config";

// styling
import "./PriceRange.scss"
import 'rc-slider/assets/index.css'

const handleStyle = {
  borderColor: "#ffffff",
  borderWidth: "1px",
  backgroundColor: "#54ac60",
  height: 20,
  width: 20,
  marginLeft: -10,
  marginTop: -8
}
const railStyle = {
  backgroundColor: "#676767"
}
const trackStyle = {
  backgroundColor: "#ffffff" 
}

const PriceRange = (props) => {
  // state
  const [range, setRange] = useState({min:props.min, max:props.max})

  // side effects
  useEffect(() => {
    setRange({min:props.min, max:props.max})
  }, [props.min, props.max])



  


  const onPriceRangeChange = (value) => {
    if (value[0] !== value[1]) {
      setRange({
        min:value[0],
        max:value[1]
      })
    }
  }

  const onPriceRangeAfterChange = (value) => {
    props.onPriceRangeChange({min:value[0],max:value[1]})
  }

  return (
    <div className="c-price-range">
      <Range min={0}
        max={200}
        marks={{
          0: `${Config.currency} 0`,
          50: "50",
          100: "100",
          150: "150",
          200: "150+"
        }}
        defaultValue={[range.min, range.max]}
        value={[range.min, range.max]}
        onChange={onPriceRangeChange}
        onAfterChange={onPriceRangeAfterChange}
        handleStyle={[handleStyle, handleStyle]}
        railStyle={railStyle}
        trackStyle={[trackStyle, trackStyle]}
        step={null} // setting to null will make sure user can only select marks (and not values between)
      />
    </div>
  )
}

PriceRange.propTypes = {
  onPriceRangeChange: PropTypes.func.isRequired
}

export default PriceRange